import { cn } from "@vseh/ui";

/**
 * Статус агента — точка-индикатор + текст. Используется в начале
 * AgentBubble'а и в системных списках (Multi-Agent Console).
 *
 * Цвета и поведение по статусам:
 *   thinking | searching | acting  → ai-500, пульсирует
 *   waiting_human                   → heritage-500, не пульсирует
 *   completed                       → success-500
 *   failed                          → danger-500
 *   idle                            → base-400
 */
export type AgentStatusValue =
  | "thinking"
  | "searching"
  | "acting"
  | "waiting_human"
  | "completed"
  | "failed"
  | "idle";

const STATUS: Record<
  AgentStatusValue,
  { dot: string; label: string; pulse: boolean }
> = {
  thinking:      { dot: "bg-ai-500",       label: "Думаю...",   pulse: true  },
  searching:     { dot: "bg-ai-500",       label: "Ищу...",     pulse: true  },
  acting:        { dot: "bg-ai-500",       label: "Делаю...",   pulse: true  },
  waiting_human: { dot: "bg-heritage-500", label: "Жду подтверждения", pulse: false },
  completed:     { dot: "bg-success-500",  label: "Готово",     pulse: false },
  failed:        { dot: "bg-danger-500",   label: "Ошибка",     pulse: false },
  idle:          { dot: "bg-base-400",     label: "Бездействует", pulse: false },
};

export interface AgentStatusProps {
  status: AgentStatusValue;
  /** Подменяет дефолтную подпись (например, «Звоню в 1С»). */
  label?: string;
  className?: string;
}

export function AgentStatus({ status, label, className }: AgentStatusProps): JSX.Element {
  const meta = STATUS[status];
  return (
    <span className={cn("inline-flex items-center gap-2 text-sm text-base-700", className)}>
      <span
        className={cn(
          "size-2 rounded-full",
          meta.dot,
          meta.pulse && "animate-agent-pulse",
        )}
        aria-hidden="true"
      />
      <span>{label ?? meta.label}</span>
    </span>
  );
}
